import type { ContentRelationKey } from '@generalTypes/apiTypes';
import type { RootState } from '@generalTypes/rootStateTypes';
import type { EducationalActivityType } from '@generalTypes/samTypes';
import type { EditAsideFoundationalSuggestions } from '@nodeTypeConfig/configTypes';
import { addRelationAction, removeRelationAction } from '@store/actions/documentActions';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCurrentEditNode } from '../../../hooks/UseCurrentEditNode';
import { useEditHref } from '../../../hooks/UseEditHref';
import { selectFoundationalSuggestions } from './AsideFoundationalSuggestionsSelectors';

import './AsideFoundationalSuggestions.scss';

const AsideFoundationalSuggestions: React.FC<{
  config: EditAsideFoundationalSuggestions;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();
  const editHref = useEditHref();
  const currentNode = useCurrentEditNode();

  const options = useSelector(
    (state: RootState) => selectFoundationalSuggestions(state, editHref, config) || [],
  );

  const change = (
    value: boolean,
    activity: EducationalActivityType & {
      isChecked?: boolean;
      relationKey?: ContentRelationKey | undefined;
    },
  ) => {
    if (value) {
      const newRelation = {
        relationtype: config.options.relationType,
        strength: 'MEDIUM',
        from: {
          href: currentNode.$$meta.permalink,
        },
        to: {
          href: activity.$$meta.permalink,
        },
      };

      dispatch(addRelationAction(newRelation, true, false));
    } else {
      dispatch(removeRelationAction(activity.relationKey));
    }
  };

  return (
    <>
      {config.label && <label className="control-label control-label-inline">{config.label}</label>}
      <div className={'foundationalSuggestions'}>
        <div className="row" style={{ marginLeft: '15px', marginRight: '15px' }}>
          <div className="col-md-6">
            {options.map((option) => (
              <div className="checkbox-row" key={option.key}>
                <input
                  id={option.key}
                  type="checkbox"
                  checked={option.isChecked}
                  onChange={(input) => change(input.target.checked, option)}
                />
                <label
                  htmlFor={option.key}
                  className={`option${readonly ? ' aside-component-disabled' : ''}`}
                >
                  {option.name}
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AsideFoundationalSuggestions;

AsideFoundationalSuggestions.displayName = 'AsideFoundationalSuggestions';

AsideFoundationalSuggestions.propTypes = {
  config: any,
  readonly: any,
};
